<template>
  <b-card>
    <b-alert variant="danger" :show="errors.length > 0">
      <p v-for="x in errors" v-bind:key="x">{{ x }}</p>
    </b-alert>
    <b-row>
      <b-col cols="3">
        <div>
          <b-form-group id="title-group-1" label="عکس: " label-for="title-1">
            <imgCropper v-model="sLink.image_id"></imgCropper>
          </b-form-group>
        </div>
        <div v-if="sLink.image_id != ''">
          <b-img :src="sLink.fileUrl" fluid></b-img>
        </div>
      </b-col>
      <b-col>
        <b-row>
          <b-col>
            <b-form-group label="عنوان: " label-for="shepa_link_title">
              <b-form-input id="shepa_link_title" aria-describedby="shepa_link_title_describe"
                :state="validateState('title')" v-model="sLink.title" placeholder="عنوان "></b-form-input>
              <b-form-invalid-feedback id="shepa_link_title_describe">لطفا عنوان را وارد کنید</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col v-if="false">
            <b-form-group id="price_is_attribute-group-2" label="نوع مبلغ: " label-for="price_is_attribute-2">
              <b-form-select id="price_is_attribute-2" v-model="sLink.price_is_attribute"
                :options="is_attribute"></b-form-select>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="موجودی: " label-for="shepa_link_count_limit">
              <b-form-input id="shepa_link_count_limit" aria-describedby="shepa_link_count_limit_describe"
                :state="validateState('count_limit')" required v-model="sLink.count_limit"
                placeholder="در صورت بینهایت آن را  0 قرار دهید"></b-form-input>
              <b-form-invalid-feedback id="shepa_link_count_limit_describe">لطفا موجودی را وارد
                کنید</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group id="price_is_attribute-group-1" label="قیمت (ریال): " label-for="input-1"
              v-if="sLink.price_is_attribute == 0">
              <NumberSeprator v-model="sLink.price"></NumberSeprator>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group label="توضیحات: " label-for="shepa_link_description">
              <b-form-textarea id="shepa_link_description" aria-describedby="shepa_link_description_describe"
                :state="validateState('description')" v-model="sLink.description" placeholder="توضیحات مربوطه"
                rows="4"></b-form-textarea>
              <b-form-invalid-feedback id="shepa_link_description_describe">لطفا توضیحات را وارد
                کنید</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <div v-if="sLink.price_is_attribute == 1">
      <b-row>
        <b-col cols="8">
          <!-- <b-alert variant="warning" :show="AttrsChanged">
            <span v-for="item in selectedAttrs" v-bind:key="item.id">{{item.title}} </span>
          </b-alert>-->
          <b-row :class="{ 'red-back': row_error.indexOf(itemIndex) >= 0 }"
            v-for="(epa, itemIndex) in sLink.easypay_attributes" v-bind:key="itemIndex">
            <b-col v-for="(item, index) in selectedAttrs" v-bind:key="item.id">
              <b-form-group id="price_is_attribute-group-1" :label="item.title + ': '" label-for="input-1">
                <b-form-select id="price_is_attribute-2" v-model="epa.attributes[index]" value-field="id"
                  text-field="title" @change="AddIfLast(itemIndex)" :options="item.attributes.filter((element) => {
                    return element.checked;
                  })
                    "></b-form-select>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group id="price_is_attribute-group-1" label="قیمت (ریال): " label-for="input-1">
                <NumberSeprator v-model="epa.price"></NumberSeprator>
              </b-form-group>
            </b-col>
            <b-col class="aligner jcr">
              <b-icon @click="removeItemEA(epa.id, itemIndex)" icon="trash" variant="danger" font-scale="1.2"></b-icon>
            </b-col>
          </b-row>
        </b-col>
        <b-col>
          <b-card no-body class="mb-1" v-for="grp in attributegroup" v-bind:key="grp.id">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle="'accordion-' + grp.id" variant="success">{{ grp.title }}</b-button>
            </b-card-header>
            <b-collapse :id="'accordion-' + grp.id" visible accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <b-row v-for="art in grp.attributes" v-bind:key="art.id">
                  <b-col>
                    <b-form-checkbox value="orange" @change="AttrsChanged = true" v-model="art.checked">{{ art.title
                      }}</b-form-checkbox>
                  </b-col>
                </b-row>
                <b-row class="text-center">
                  <b-col>
                    <b-button variant="primary" @click="ShowaddAttr(grp.id)">
                      ویرایش گروه {{ grp.title }}</b-button>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-collapse>
          </b-card>
          <b-button block variant="primary" @click="ShowaddAttr(0)">جدید</b-button>
        </b-col>
      </b-row>
    </div>
    <b-button variant="danger" href="/shepaLink">بازگشت</b-button>
    <b-button class="ml-3" variant="success" @click="Save()">ذخیره</b-button>

    <b-modal id="addattrmodal" title="ثبت شرایط خاص" ok-title="ذخیره" cancel-title="انصراف" @ok="saveAttr">
      <b-row>
        <b-col>
          <b-form-group id="attr_grpTitle-group-1" label="عنوان گروه : " label-for="attr_grpTitle">
            <b-form-input v-bind:class="{
              'is-invalid':
                !$v.newattr.title.required && $v.newattr.title.$dirty,
              'is-valid':
                $v.newattr.title.required && $v.newattr.title.$dirty,
            }" id="attr_grpTitle" aria-describedby="attr_grpTitle_describe" required v-model="newattr.title"
              placeholder="عنوان گروه "></b-form-input>
            <b-form-invalid-feedback id="attr_grpTitle_describe">لطفا عنوان گروه را وارد کنید</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="r-m-t" v-for="(x, index) in $v.newattr.attributes.$each.$iter" :key="index">
        <b-col cols="10">
          <b-form-input v-bind:class="{
            'is-invalid': !x.title.required && x.title.$dirty,
            'is-valid': x.title.required && x.title.$dirty,
          }" :aria-describedby="'attr_sub_grpTitle_describe_' + index" required v-model="x.title.$model"
            @focus="addattritem()" placeholder="عنوان زیر گروه "></b-form-input>
          <b-form-invalid-feedback :id="'attr_sub_grpTitle_describe_' + index">لطفا عنوان زیر گروه را وارد
            کنید</b-form-invalid-feedback>
        </b-col>
        <b-col cols="2" class="text-center aligner">
          <div v-if="index == newattr.attributes.length - 1">
            <b-icon @click="addattritem()" icon="plus" variant="success" font-scale="2"></b-icon>
          </div>
          <div v-else style="width: 22px"></div>

          <b-icon @click="removeItem(x.id, index)" icon="trash" variant="danger" font-scale="1.2"></b-icon>
        </b-col>
      </b-row>
    </b-modal>
  </b-card>
</template>
<style>
.aligner {
  display: flex;
  align-items: center;
  justify-content: center;
}

.r-m-t {
  margin-top: 20px;
}

.jcr {
  justify-content: right !important;
}

.custom-select.is-valid,
.was-validated .custom-select:valid {
  background: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5'%3E%3Cpath fill='%231B283F' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E") no-repeat left 1rem center/8px 10px,
    url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8'%3E%3Cpath fill='%231BC5BD' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3E%3C/svg%3E") #fff no-repeat center left 2rem / calc(0.75em + 0.65rem) calc(0.75em + 0.65rem);
}

.custom-select.is-invalid,
.was-validated .custom-select:invalid {
  background: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5'%3E%3Cpath fill='%231B283F' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E") no-repeat left 1rem center/8px 10px,
    url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23F64E60'%3E%3Ccircle cx='6' cy='6' r='4.5'/%3E%3Cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3E%3Ccircle cx='6' cy='8.2' r='.6' fill='%23F64E60' stroke='none'/%3E%3C/svg%3E") #fff no-repeat center left 2rem / calc(0.75em + 0.65rem) calc(0.75em + 0.65rem);
}

.red-back input,
.red-back select {
  border-color: #f64e60;
}
</style>
<script>
import { validationMixin } from "vuelidate";
import { email, required, minLength, url } from "vuelidate/lib/validators";
import imgCropper from "../../components/imgCropper";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import MDDropdown from "../../components/MDDropdown";
import httpHelper from "../../helpers/httpHelper";
import fileUploader from "../../components/fileUploader";
import NumberSeprator from "../../components/numberSeprator";
import routesMap from '@/helpers/routesMap'
const numbers = (value, vm) => !/[^0-9]/.test(value);

export default {
  mixins: [validationMixin],
  name: "newShepaLink",
  data() {
    return {
      AttrsChanged: false,
      is_attribute: [
        { text: "استفاده از قیمت ثابت", value: "0" },
        { text: "استفاده از قیمت ترکیبی", value: "1" },
      ],
      sLink: {
        image_id: "1490e320-928d-4986-a013-91f7832db455",
        title: "",
        mdid21_status: 1650,
        price_is_attribute: 0,
        description: "",
        count_limit: 0,
        price: 0,
        wallet_id: 0,
        input_email_require: 1,
        input_mobile_require: 1,
        input_name_require: 1,
        input_note_require: 1,
        easypay_attributes: [
          { id: 0, attributes: [], price: 0, is_default: true },
        ],
        fileUrl: null,
      },
      attributegroup: [],
      wallets: [],
      errors: [],
      newattr: {
        id: 0,
        title: "",
        status: 1,
        attributes: [{ id: 0, index: 0, title: "" }],
      },
      newattr_fields: [
        {
          key: "title",
          label: "زیر جزء",
        },
      ],
      row_error: [],
      routesMap,
    };
  },
  validations: {
    sLink: {
      title: {
        required,
        minLength: minLength(3),
      },
      description: {
        required,
        minLength: minLength(3),
      },
      count_limit: {
        required,
        numbers,
      },
    },
    newattr: {
      title: {
        required,
        minLength: minLength(3),
      },
      attributes: {
        $each: {
          title: {
            required,
            minLength: minLength(3),
          },
        },
      },
    },
  },
  components: {
    MDDropdown,
    fileUploader,
    NumberSeprator,
    imgCropper,
  },
  mounted() {
    httpHelper.getData("wallets").then((response) => {
      this.wallets = response.result.map((item) => {
        return {
          text: item.wallet_name,
          value: item.id,
        };
      });
    });
    httpHelper.getImage(this.sLink.image_id).then((res) => {
      this.sLink.fileUrl = res.result.url;
    });
    this.getAttrs();
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "شپا لینک", route: "/shepaLink" },
      { title: "لینک جدید" },
    ]);
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.sLink[name];
      return $dirty ? !$error : null;
    },
    getAttrs() {
      httpHelper.getData("attributegroup").then((res) => {
        this.attributegroup = res.result;
      });
    },
    saveAttr(e) {
      e.preventDefault();
      this.$v.newattr.$touch();
      if (this.$v.newattr.$anyError) {
        return;
      }
      httpHelper.postData("attributegroup", this.newattr).then((res) => {
        this.getAttrs();
        this.$bvModal.hide("addattrmodal");
      });
    },
    removeItem(selectdId, selected_index) {
      this.newattr.attributes.splice(
        this.newattr.attributes.indexOf(selected_index),
        1
      );
      if (this.newattr.attributes.length == 0) {
        this.addattritem();
      }
    },
    removeItemEA(selectdId, selected_index) {
      if (this.sLink.easypay_attributes.length > 1) {
        this.sLink.easypay_attributes.splice(
          this.sLink.easypay_attributes.indexOf(selected_index)
        );
      }
    },
    ShowaddAttr(group_id = 0) {
      if (group_id == 0) {
        this.newattr = {
          id: 0,
          title: "",
          attributes: [{ id: 0, index: 0, title: "" }],
        };
      }
      else {
        httpHelper.getData("attributegroup?id=" + group_id).then((response) => {
          if (response.success) {
            this.newattr = response.result[0];
          }
        });
      }
      this.$v.newattr.$reset();
      this.$bvModal.show("addattrmodal");
    },
    addattritem(index) {
      this.newattr.attributes.push({
        index: this.newattr.attributes.length,
        title: "",
      });
    },
    Save() {
      this.$v.sLink.$touch();
      if (this.$v.sLink.$anyError) {
        return;
      }
      this.errors = [];
      this.row_error = [];
      var select_count = this.selectedAttrs.length;
      if (this.sLink.price_is_attribute == "1") {
        for (var i = 0; i < this.sLink.easypay_attributes.length; i++) {
          if (
            this.sLink.easypay_attributes[i].price == 0 ||
            this.sLink.easypay_attributes[i].price == null
          ) {
            this.row_error.push(i);
          }
          if (
            this.sLink.easypay_attributes[i].attributes.length < select_count
          ) {
            this.row_error.push(i);
          }
        }
      }
      if (this.row_error.length == 0) {
        httpHelper.postData("easypay", this.sLink).then((response) => {
          if (response.success) {
            this.$router.push("/shepaLink");
          } else {
            for (var key in response.error) {
              response.error[key].forEach((element) => {
                this.errors.push(element);
              });
            }
          }
        });
      }
    },
    AddIfLast(index) {
      if (index + 1 == this.sLink.easypay_attributes.length) {
        this.sLink.easypay_attributes.push({
          attributes: [],
          price: 0,
          is_default: true,
        });
      }
    },
  },
  computed: {
    selectedAttrs() {
      return this.attributegroup.filter((element) => {
        var d = element.attributes.filter((attrItem) => {
          return attrItem.checked;
        });
        return d.length > 0;
      });
    },
  },
};
</script>